import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as cls from 'classnames';
import { Route, Link, withRouter } from 'react-router-dom';
import Moment from 'react-moment';


@withRouter
export class Item extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.onNotificationClick = this.onNotificationClick.bind(this);
    }

    onNotificationClick(){
        this.props.loadPost(this.props.forum.id, this.props.item.forumPostId);
    }

    render() {
        const {item, forum} = this.props;

        var message = "";
        switch(item.notificationType){
            case "LIKE":
            message = " liked your comment "
            break;
            case "TAG":
            message = " has tagged you in"
            break;
            case "CREATED":
            message = " has commented on your post "
            break;
        }
        let snippitLen = 36;
        let post = forum && forum.posts ? forum.posts.find(p => p.id === item.forumPostId) : undefined;
        let snippet = post && post.comment ? 
                            post.comment.substring(0, snippitLen) + (post.comment.length > snippitLen ? "..." : "") : undefined;
        if(snippet) {
            snippet.replace("</b...", "</b>...").replace("</...", "</b>...").replace("<...", "</b>...");
            snippet.replace("<b>...", "...").replace("<b...", "...").replace("<...", "...");
        }
        let avatarImg = item.avatarId ? 
                                    `/api/attachment/${item.avatarId}` : 
                                    require("../../../assets/img/Unconfirmed.png");
        return (    
            <div className="row clickable" onClick={this.onNotificationClick}>
                <div className="col-2 col-lg-1 pt-2 pr-0">
                    <div className="circle-avatar">
                        <img src={avatarImg} />
                    </div>
                </div>
                <div className="col-10 col-lg-11 my-2">
                    <span className="badge badge-pill badge-default pull-right">{!item.markAsRead ? "NEW" : "READ"}</span>
                    <strong>{item.firstName} {item.lastName}</strong> {message} "<span dangerouslySetInnerHTML={{ __html: snippet }} />"
                            
                    <div className="text-muted small">
                        <Moment fromNow>{item.creationDate}</Moment>
                    </div>
                </div>
            </div> 
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/DiscussionBoard/Notifications/Item.tsx